export default function IntroBlock() {
    return (
        <section className='intro'>
            <div className='container'>
                <p>Organizations around the world are making the shift from project to product to master software at scale and survive the next decade of digital disruption.</p>
                <p>The <strong>Project to Product Maturity Assessment</strong> benchmarks key components of the project to product shift and provides practical recommendations on how to advance in this five-stage journey.</p>
                <ul>
                    <li>Answer seven questions in five minutes</li>
                    <li>Immediately reveal your stage in the journey</li>
                    <li>Get substantive advice on how to advance to the next stage</li>
                    <li>Unlock a free e-book that maps all the stages and charts the path to your ultimate maturity goal</li>
                </ul>
            </div>
        </section>
    )
}